import { enGB } from 'date-fns/locale/en-GB';
import { enUS } from 'date-fns/locale/en-US';

const US_LOCALE_PREFIX = 'en-us';

/**
 * Maps a BCP-47 locale string (e.g. `navigator.language`) to a date-fns locale
 * object. The mapping is intentionally binary:
 *
 * - `en-US` (and its subtags) → `enUS` — 12h clock, `M/d/y` date order.
 * - Everything else → `enGB` — 24h clock, `d/M/y` date order, English month
 *   and weekday names.
 *
 * We pick `enGB` (not `de` / `fr` / etc.) for the non-US branch because the
 * UI copy is English; we only need the *format* of dates and times to flip,
 * not the language of month / weekday labels.
 *
 * @param {string} [locale] BCP-47 tag. Defaults to `navigator.language`.
 * @returns {import('date-fns/locale').Locale}
 */
export const getDateFnsLocale = (locale = window.navigator.language) => {
	if (typeof locale !== 'string' || locale.length === 0) return enGB;
	return locale.toLowerCase().startsWith(US_LOCALE_PREFIX) ? enUS : enGB;
};
